<template>
    <div class="grid lg:grid-cols-3 grid-cols-1 md:grid-cols-2 mt-20 gap-15">
        <WorkplaceGridItem
            v-for="cafe in cafes"
            :key="cafe.id"
            :cafe="cafe"
        />
    </div>
</template>

<script>
import WorkplaceGridItem from "./WorkplaceGridItem";

export default {
    name:       "WorkplaceGrid",
    components: {WorkplaceGridItem},
    props:      {
        cafes: Array
    }
}
</script>
